/* eslint-disable no-console */

import {
  getCourseLevels,
  getCourseLevelLiveProject,
  getCourseLevelInternship
} from '../api/v1/courseLevel';
import {
  ADD_COURSE_LEVEL_LIVE_PROJECT,
  ADD_COURSE_LEVEL_INTERNSHIP,
  CHANGE_COURSE_LEVEL,
  FETCH_COURSE_LEVEL_DATA
} from '../constants/actionTypes';

export const addCourseLevel = (courseKey, value, extraData) => ({
  courseKey,
  value,
  extraData
});

export const changeCourseLevel = level => ({
  type: CHANGE_COURSE_LEVEL,
  level
});

export const fetchCurrentCourseCourseLevel = courseKey => (dispatch, start) => {
  start(FETCH_COURSE_LEVEL_DATA);
  return getCourseLevels(courseKey).then(response => {
    return addCourseLevel(courseKey, response.data, response.included);
  });
};

export const addCourseLevelLiveProject = (courseLevelId, value) => ({
  type: ADD_COURSE_LEVEL_LIVE_PROJECT,
  payload: { courseLevelId, value }
});

export const fetchCourseLevelLiveProject = courseLevelId => dispatch =>
  getCourseLevelLiveProject(courseLevelId)
    .then(response => {
      dispatch(addCourseLevelLiveProject(courseLevelId, response.data));
    })
    .catch(error => console.log(error));

export const addCourseLevelInternship = (courseLevelId, value) => ({
  type: ADD_COURSE_LEVEL_INTERNSHIP,
  payload: { courseLevelId, value }
});

export const fetchCourseLevelInternship = courseLevelId => dispatch =>
  getCourseLevelInternship(courseLevelId)
    .then(response => {
      dispatch(addCourseLevelInternship(courseLevelId, response.data));
    })
    .catch(error => console.log(error));



// WEBPACK FOOTER //
// ./src/actions/courseLevel.js